export default "__VITE_ASSET__Da9N02Wt__"